import styled from 'styled-components'

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import { Typography } from 'components/Typography/Typography'
import { Tabs } from 'components/Tabs/Tabs'
import { Wallets } from './Wallets/Wallets'
import { Positions } from './Positions/Positions'
import { useIsMobile } from 'utils/useIsMobile'
import { useGlobalBanner } from 'utils/useGlobalBanner'
import { GLOBAL_BANNER_HEIGHT } from 'components/GlobalBanner/GlobalBanner'

const Page = styled.div<{ $hasBanner: boolean }>`
  min-height: calc(100vh - 462px);
  margin-top: calc(124px + ${props => (props.$hasBanner ? GLOBAL_BANNER_HEIGHT : 0)}px);

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-top: calc(100px + ${props => (props.$hasBanner ? GLOBAL_BANNER_HEIGHT : 0)}px);

    & > nav {
      padding: 0 20px;
    }

    // & > div {
    //   margin-top: -40px;
    // }
  }
`

const LeaderboardWrapper = styled.div`
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding: 0px 20px;
  }
`

const LeaderboardContainer = styled.div`
  max-width: 1200px;
  margin: auto;
  position: relative;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    & > div {
      font-size: ${p => p.theme.typography.size.Subtitle2}px;
      text-align: center;
    }
  }
`

export const Leaderboard = () => {
  const isMobile = useIsMobile()

  const { isEnabled: hasBanner } = useGlobalBanner()

  const tabData = [
    {
      label: 'Wallets',
      content: <Wallets />,
    },
    {
      label: 'Positions',
      content: <Positions />,
    },
  ]

  return (
    <Page $hasBanner={hasBanner}>
      <Breadcrumbs
        items={[
          { label: 'Home', path: '/' },
          { label: 'Leaderboard', path: '/leaderboard' },
        ]}
      />
      <LeaderboardWrapper>
        <LeaderboardContainer>
          <Typography variant="title2" fontWeight="bold" style={{ marginTop: 32 }}>
            Leaderboard
          </Typography>
          <Tabs
            tabStyles={{ maxWidth: 180 }}
            tabsStyles={{ justifyContent: 'flex-start', marginTop: isMobile ? 0 : 24 }}
            tabPanelStyles={{ padding: '0', fontSize: 20 }}
            tabs={tabData}
          />
        </LeaderboardContainer>
      </LeaderboardWrapper>
    </Page>
  )
}
